import getAttributesImport from '../../settings/attributes'
import { constants as backendConstants, selectors as backendSelectors } from '../Backend/exports'
import { actions as toasterActions } from '../Toaster'
import { selectors as commonTextsSelectors } from '../CommonTexts'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    return {
        ssoUrlFormat: attributes.service.sso.login,
    }
}

export const actions = {
    showError: toasterActions.addError,
}

export const selectors = {
    getActiveServer: state => backendSelectors.getActiveServer(state),
    getLocale: state => backendSelectors.getLocale(state),
    getErrorText: state => commonTextsSelectors.getErrorText(state),
    getErrorLoginUserText: state => commonTextsSelectors.getErrorLoginUserText(state),
}

export const constants = {
    ACTIVE_SERVER_CHANGED: backendConstants.ACTIVE_SERVER_CHANGED,
}



// WEBPACK FOOTER //
// ./src/features/Steam/imports.js